import axios from '@/load_axios'
import { API_HOST } from '@/constants';
import loadBearing from '../../public/load-bearing.json'
const BASE_URL = `${API_HOST}/wp-json/wp/v2/banner`
const BASE_CATEGORY_URL = `${API_HOST}/wp-json/wp/v2/banner-category`

function localLink(banner) {
    const split = banner.acf.url.split(API_HOST)
    if( split.length > 1  && split[0] == "" ) {
        banner.local_url = split[1]
    }
}

const banners = {
    namespaced: true,
    state: {
        all: [],
        square: null,
        squareCategory: null,
        wide: null,
        wideCategory: null,
    },
    getters: {
        all: (state) => {
            return [...state.all]
        },
        last: (state) => {
            const mags = [...state.all]
            return mags.sort((a, b) => b.date - a.date)[0]
        },
        slug: (state) => (slug) => {
            return state.all.find( post => post.slug == slug)
        },
    },
    mutations: {
        add(state, posts) {
            for(let post of posts) {
                localLink(post)
                const index = state.all.findIndex( storedPost => storedPost.id === post.id)
                if(index === -1) {
                    state.all.push(post)
                } else {
                    state.all.splice(index, 1, post)
                }
            }
        },
        setSquareCategory(state, category) {
            state.squareCategory = category
        },
        setSquareBanner(state, banner) {
            localLink(banner)
            state.square = banner
        },
        setWideCategory(state, category) {
            state.wideCategory = category
        },
        setWideBanner(state, banner) {
            localLink(banner)
            state.wide = banner
        },
    },
    actions: {
        async getAll({commit}) {
            const res = await axios.get(BASE_URL)
            commit('add', res.data)
        },
        async getWideCategory({commit, state, dispatch}) {
            if( state.wideCategory != null ) {
                return
            }
            const res = await axios.get(`${BASE_CATEGORY_URL}`, {
                params: {slug: loadBearing.terms['banner-category'].wide}
            })
            if( res.data.length == 0 ) {
                return
            }
            commit('setWideCategory', res.data[0])
            dispatch('getWide')
        },
        async getSquareCategory({commit, state, dispatch}) {
            if( state.squareCategory != null ) {
                return
            }
            const res = await axios.get(`${BASE_CATEGORY_URL}`, {
                params: {slug: loadBearing.terms['banner-category'].square}
            })
            if( res.data.length == 0 ) {
                return
            }
            commit('setSquareCategory', res.data[0])
            dispatch('getSquare')
        },
        async getLast({commit}) {
            const res = await axios.get(BASE_URL, {
                params: { limit: 1 }
            })
            commit('add', res.data)
        },
        async getWide({state, dispatch, commit}) {
            if( state.wideCategory == null ) {
                dispatch('getWideCategory')
                return
            }
            const catId = state.wideCategory.id
            const res = await axios.get(`${BASE_URL}`, {
                params: {'banner-category': catId}
            })
            if( res.data.length == 0 ) {
                return
            }
            commit('setWideBanner', res.data[0])
        },
        async getSquare({state, dispatch, commit}) {
            if( state.squareCategory == null ) {
                dispatch('getSquareCategory')
                return
            }
            const catId = state.squareCategory.id
            const res = await axios.get(`${BASE_URL}`, {
                params: {'banner-category': catId}
            })
            if( res.data.length == 0 ) {
                return
            }
            commit('setSquareBanner', res.data[0])
        },
        async getOne({commit}, slug) {
            const res = await axios.get(`${BASE_URL}?slug=${slug}`)
            commit('add', res.data)
            return res.data
        }
    },
}

export default banners

